var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Emit, Inject, Prop, Vue, Watch, } from "vue-property-decorator";
import EditDataElementLabel from "../components/articleattributes/editdataelementlabel.vue";
import { isNumber, } from "./utilities/wsi4_typeguards";
let MultiplicityForm = class MultiplicityForm extends Vue {
    constructor() {
        super(...arguments);
        this.multiplicity = 1;
    }
    valueChanged() { return this.multiplicity; }
    isValid() { return isNumber(this.multiplicity) && this.multiplicity > 0; }
    get showInfoIcon() { return this.networkBroker.configuration.editDataConfiguration["multiplicity"].showInfoIcon; }
    created() {
        this.multiplicity = this.defaultMultiplicity;
    }
    mounted() {
        this.multiplicity = this.defaultMultiplicity;
    }
    onMultiplicityChanged() {
        this.valueChanged();
    }
};
__decorate([
    Prop({ required: true })
], MultiplicityForm.prototype, "defaultMultiplicity", void 0);
__decorate([
    Prop({ required: true })
], MultiplicityForm.prototype, "disabled", void 0);
__decorate([
    Inject()
], MultiplicityForm.prototype, "i18n", void 0);
__decorate([
    Inject()
], MultiplicityForm.prototype, "networkBroker", void 0);
__decorate([
    Emit()
], MultiplicityForm.prototype, "valueChanged", null);
__decorate([
    Watch("multiplicity")
], MultiplicityForm.prototype, "onMultiplicityChanged", null);
MultiplicityForm = __decorate([
    Component({
        components: {
            EditDataElementLabel,
        },
        name: "MultiplicityForm",
    })
], MultiplicityForm);
export default MultiplicityForm;
